"use strict";

import http from "@/http";

const sendContact = async payload => {
  const response = await http.post("/contact/send", payload);
  return response.data;
};

export default {
  sendContact
};
